import { ChatType } from "src/app/chats-panel/~store/models/enums/ChatType";
import i18n from "src/app/shared/localization/i18n";

export const getChatTypeName = (chatType?: ChatType) => {
  switch (chatType) {
    case ChatType.Comment: return i18n.t('chat.chatTypeComment');
    case ChatType.Group: return i18n.t('chat.chatTypeGroup');
    default: return i18n.t('chat.chatTypePrivate');
  }
}


export const getChatTypeClass = (chatType?: ChatType) =>
{
  switch (chatType) {
    case ChatType.Comment: return 'chat-type-comment';
    case ChatType.Group: return 'chat-type-group';
    default:  return 'chat-type-private';
  }
}
